import { render } from "./SmallTool.vue?vue&type=template&id=285ba78f&scoped=true"
import script from "./SmallTool.vue?vue&type=script&lang=js"
export * from "./SmallTool.vue?vue&type=script&lang=js"

import "./SmallTool.vue?vue&type=style&index=0&id=285ba78f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-285ba78f"

export default script